import Actions from '../../odata/actions';

const actions = new Actions('trainingItem', 'trainingItems');

export default actions;
